import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import NewBlog from "./NewBlog";
import firebase from "firebase";
import { useEffect } from "react";
import { Card } from "react-bootstrap";
import BlogDetail from "./BlogDetail";
import "./BlogModal.css";


const BlogModal = (props) => {
  const [newBlogModalShow, setNewBlogModalShow] = useState(false);
  const [blogDetailModalShow, setBlogDetailModalShow] = useState(false);
  const [blogContentList, setContactList] = useState();
  const [blogContent, setBlogContent] = useState();
  const fetchBlogContent = async () =>{
    await firebase.database().ref('/blog/').once('value').then((snapshot) => {
      const contacts=snapshot.val()
      const contactArray = [];
      for (let id in contacts) {
        contactArray.push({ id, ...contacts[id] });
      }
      setContactList(contactArray);
  });
  }
  useEffect(() => {
    fetchBlogContent()
  }, [newBlogModalShow])
  console.log(blogContentList?.map(e => e?.content))
  
  const handleBlogDetail = (blog) =>{
    setBlogDetailModalShow(true)
    setBlogContent(blog)
  }
  




 
  return (
    <div 
    >
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      fullscreen
      className="blogModal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">BLOG</Modal.Title>
      </Modal.Header>
      <h3>Arıcılık Forumu</h3>
      <Modal.Body>
      {blogContentList?.map(blog => 
      <Card style={{  display:"flex", flexDirection:"row", margin:"1.5rem", backgroundColor:"#ffb74d" }}>
      <Card.Img style={{width:"10rem", padding:"0.5rem"}} variant="top" src={blog.imageUrl} />
      <Card.Body>
        <Card.Title>{blog?.title}</Card.Title>
        <Card.Text>
          <b>{blog?.content?.slice(0,350) + "..."}</b>
        </Card.Text>
      </Card.Body>
        <Button onClick={() => handleBlogDetail(blog)}  variant="primary">İncele</Button>
    </Card>
      )}
        

      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Kapat</Button>
        <Button onClick={() => setNewBlogModalShow(true)}>Yeni Yazı Ekle</Button>
      </Modal.Footer>
      <NewBlog
          show={newBlogModalShow}
          onHide={() => setNewBlogModalShow(false)}
        />
      <BlogDetail
          show={blogDetailModalShow}
          onHide={() => setBlogDetailModalShow(false)}
          blogContent={blogContent}
        />
    </Modal>
    </div>
  );
};
export default BlogModal;
